import React from 'react';
import tooltips from '../../assets/tooltips';
import Tooltip from '@hud/web-components/Tooltip/Tooltip';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

export interface ServicesTableProps {
  id: number;
  isPreferred: boolean;
  onSelectService: (ids: number[], isSingleService: boolean) => void;
}

export default function MyServicesIcon({
  id,
  isPreferred,
  onSelectService,
}: ServicesTableProps) {
  const tooltipDescription = isPreferred
    ? tooltips.SERVICES_TABLE.REMOVE_FROM_MY_SERVICES
    : tooltips.SERVICES_TABLE.ADD_TO_MY_SERVICES;
  const icon = isPreferred ? 'other.starActive' : 'other.star';

  return (
    <Tooltip description={tooltipDescription}>
      <HudIcon
        icon={icon}
        size="20px"
        style={{ cursor: 'pointer', verticalAlign: 'middle' }}
        onClick={() => onSelectService([id], true)}
      />
    </Tooltip>
  );
}
